var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.75C6.99594 4.75 3.75 7.99594 3.75 12C3.75 16.0041 6.99594 19.25 11 19.25C11.8907 19.25 12.7422 19.0897 13.5285 18.7971C13.9167 18.6526 14.3485 18.8502 14.493 19.2384C14.6375 19.6266 14.4399 20.0584 14.0517 20.2029C13.1006 20.5569 12.072 20.75 11 20.75C6.16751 20.75 2.25 16.8325 2.25 12C2.25 7.16751 6.16751 3.25 11 3.25C15.8325 3.25 19.75 7.16751 19.75 12C19.75 12.9536 19.5972 13.873 19.3141 14.7342C19.1848 15.1277 18.7609 15.3418 18.3674 15.2125C17.9739 15.0832 17.7598 14.6593 17.8891 14.2658C18.1231 13.5539 18.25 12.7925 18.25 12C18.25 7.99594 15.0041 4.75 11 4.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4697 11.4697C15.7626 11.1768 16.2374 11.1768 16.5303 11.4697L19 13.9393L21.4697 11.4697C21.7626 11.1768 22.2374 11.1768 22.5303 11.4697C22.8232 11.7626 22.8232 12.2374 22.5303 12.5303L19.5303 15.5303C19.2374 15.8232 18.7626 15.8232 18.4697 15.5303L15.4697 12.5303C15.1768 12.2374 15.1768 11.7626 15.4697 11.4697Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.145f38080732a82449dbfb9ac6974414.svg";
export { ForwardRef as ReactComponent };